import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M20 17H16V13H20V17ZM14 17H10V13H14V17ZM8 17H4V13H8V17ZM20 11H16V7H20V11ZM14 11H10V7H14V11ZM8 11H4V7H8V11Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "GridHorizontal"
);
